import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import NudgeArrow from '@/Atoms/NudgeArrow';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {View} from 'react-native';
import useRunAssesment from '@/Hooks/AssessmentApi/useRunAssesment';
import useAlertModalStore from '@/Store/AlertModalStore';
import {useNonPersistedUserPlanStore} from '@/Store/userPlanStore';
import {useEffect} from 'react';

interface RunAssessmentProps {
  withContentStyle?: boolean;
  onLoadingChange?: (loading: boolean) => void;
}

const RunAssessment = ({
  withContentStyle = false,
  onLoadingChange,
}: RunAssessmentProps) => {
  const {setSubscriptionModalOpen} = useNonPersistedUserPlanStore();
  const openAlertModal = useAlertModalStore(state => state.openModal);

  const handleOnSuccess = (responseData: any) => {
    if (responseData?.data?.is_permitted === false) {
      setSubscriptionModalOpen(true);
    } else if (responseData?.data?.success) {
      // setSubscriptionModalOpen(true);
      openAlertModal({
        header: 'Info',
        bodyTxt: 'Your assessment is started and will be available in a while',
      });
    }
    // setAvatar(responseData.data?.avatar);
    // if (responseData.data?.game) {
    //   setGameForReview(responseData.data?.game);
    // }
    // setPuzzle(responseData.data?.puzzle);
    // setScorecards(responseData.data?.scorecards);
    // setUserEmail(responseData.data?.user.email);
    // setUserAvatar(responseData.data?.avatar.avatar);
    // setUserIcon(responseData.data?.avatar.avatarDP);
    // setUserGems(responseData.data?.user.gems);
    // setUserId(responseData.data?.user.username);
    // setUserLevel(responseData.data?.avatar.level);
    // setUserProgress(responseData.data?.avatar.progress);
    // setNetCCPoints(responseData.data?.user.net_score);
    // setMasterPuzzle(responseData.data?.master_puzzle);
  };

  const handleOnError = (error: any) => {
    console.log('Error occurred in Dashboard API: ', error);
  };

  const {
    mutate: runAssessment,
    data: runAssessmentData,
    error: runAssessmentError,
    isLoading: runAssessmentLoading,
  } = useRunAssesment(handleOnSuccess, handleOnError);

  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(runAssessmentLoading);
    }
  }, [runAssessmentLoading, onLoadingChange]);

  return (
    <View style={{marginTop: 10}}>
      <CCButton
        // type="none"
        style={{}}
        animated
        onPress={() => {
          openAlertModal({
            header: 'Confirm',
            bodyTxt: 'Are you sure you want to run the assessment?',
            buttonText: 'Yes', // Custom button text
            handleConfirmation: () => {
              runAssessment();
            },
          });
        }}
        contentContainerStyle={
          withContentStyle
            ? {
                paddingHorizontal: 2,
                paddingVertical: 8,
                backgroundColor: CCColors.BrightYellow,
                flexDirection: 'row',
              }
            : undefined
        }>
        <CCText fontWeight={500} fontSize={FontSizes[14]}>
          Run assessment
        </CCText>
        <NudgeArrow fontSize={FontSizes[14]} style={{marginLeft: 6}} />
        {/* <Box flexDirection="row" justifyContent="space-between">
            <CCText
                fontSize={FontSizes[16]}
                fontWeight="500"
                style={[{marginRight: 16, ...OPACITY}]}>
                <CCText
                fontSize={FontSizes[16]}
                fontWeight="500"
                style={[
                    {
                    marginRight: 8,
                    alignSelf: 'flex-start',
                    ...OPACITY,
                    },
                ]}
                color="#67B3E1">
                ▪
                </CCText>
                Run assessment
            </CCText>
            <MaterialCommunityIcon
                name="arrow-top-right"
                size={16}
                color={'#4D3F37'}
            />
        </Box> */}
      </CCButton>
      {/* <CCText
            fontWeight="500"
            size={12}
            textAlign="right"
            color={CCColors.TextColor.Grey}>
            Updated: 1 day ago
        </CCText> */}
    </View>
  );
};

export default RunAssessment;
